import React from 'react';
import {Link} from 'react-router-dom';
import routes from 'globals/routes';
import { useDataValue } from 'globals/contexts/dataContext';
import './contactBlock.css';
const ContactBlock = () => {
  const [{currentLanguage}, _] = useDataValue();
  
  return (
    <div className="contactBlock">
      <span className="link">{currentLanguage === 'tc'? '聯絡我們': 'Contact Us'}</span>
      <a className="link" href="mailto:info@callisupply.hk">info@callisupply.hk</a>
      {/* <a className="link" href="#">+852 9222 2255</a> */}
      {/* <span className="link">&nbsp;</span>
      <Link className="link" to={routes.pageWithLang('privacy', currentLanguage)}>{currentLanguage === 'tc'? 'Privacy Policy': 'Privacy Policy'}</Link>
      <Link className="link" to={routes.pageWithLang('legal', currentLanguage)}>{currentLanguage === 'tc'? 'Legal Terms': 'Legal Terms'}</Link> */}
      {/* <a className="link" href="#">Legal Terms</a> */}
    </div>
  );
}

export default ContactBlock;